export const deferImages = () => {
  var imgs = document.querySelectorAll('img[data-src]');

  for (var index = 0; index < imgs.length; index++) {
    var img = imgs[index];
    
    img.setAttribute('src', img.getAttribute('data-src'));
  }
};